import { Link } from 'react-router-dom';
import { PageTransition, StaggeredReveal } from '../components/common/PageTransition';

const Services = () => {
  const services = [
    {
      title: 'Market Analysis',
      description: 'Deep dive into regional and national agricultural trends to spot opportunities.',
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
    },
    {
      title: 'Vendor Marketplace',
      description: 'A dedicated platform for vendors to sell seeds, fertilizers, and tools directly to farmers.',
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
    },
    {
      title: 'Smart Farming Advisory',
      description: 'AI-powered crop recommendations based on soil data, weather patterns, and market demand.',
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
    },
    {
      title: 'Import/Export Intelligence',
      description: 'Comprehensive data on international trade flows for policymakers and large-scale traders.',
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      title: 'AI-Powered Price Predictions',
      description: 'Get forecasts for future crop prices and receive alerts to help with planning.',
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
    },
    {
      title: 'Community & Knowledge Hub',
      description: 'Join discussions with other farmers and get AI-powered support for agricultural questions.',
      icon: (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
    },
  ];

  return (
    <PageTransition>
      {/* Hero section */}
      <StaggeredReveal delay={0.1}>
        <div className="relative bg-green-800">
          <div className="absolute inset-0">
            <img
              className="w-full h-full object-cover"
              src="https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80"
              alt="Farmers working in the field"
            />
            <div className="absolute inset-0 bg-green-800 mix-blend-multiply" />
          </div>
          <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
              Our Services
            </h1>
            <p className="mt-6 text-xl text-green-100 max-w-3xl">
              Comprehensive solutions to help farmers succeed in today's agricultural landscape.
            </p>
          </div>
        </div>
      </StaggeredReveal>

      {/* Services section */}
      <div className="py-16 bg-white dark:bg-gray-900 overflow-hidden lg:py-24">
        <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
          <div className="relative">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
              {services.map((service, index) => (
                <StaggeredReveal key={service.title} delay={0.2 + index * 0.1}>
                  <div
                    className="relative group bg-white dark:bg-gray-800 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-green-500 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200"
                  >
                    <div>
                      <span className="rounded-lg inline-flex p-3 bg-green-50 dark:bg-green-900 text-green-700 dark:text-green-300 ring-4 ring-white dark:ring-gray-700">
                        {service.icon}
                      </span>
                      <h3 className="mt-8 text-lg font-medium text-gray-900 dark:text-white">{service.title}</h3>
                      <p className="mt-2 text-base text-gray-500 dark:text-gray-300">{service.description}</p>
                    </div>
                  </div>
                </StaggeredReveal>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Additional features section */}
      <StaggeredReveal delay={0.8}>
        <div className="bg-gray-50 dark:bg-gray-800 py-16 sm:py-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="lg:text-center">
              <h2 className="text-base text-green-600 dark:text-green-400 font-semibold tracking-wide uppercase">Additional Features</h2>
              <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
                More ways to grow your business
              </p>
            </div>

            <div className="mt-10">
              <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                <StaggeredReveal delay={0.9}>
                  <div className="relative">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">Government & NGO Integration</h3>
                    <p className="mt-2 text-base text-gray-500 dark:text-gray-300">
                      Track production and access grants, subsidies, and training programs.
                    </p>
                  </div>
                </StaggeredReveal>
                <StaggeredReveal delay={1.0}>
                  <div className="relative">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">Logistics & Transport</h3>
                    <p className="mt-2 text-base text-gray-500 dark:text-gray-300">
                      Connect with transport services for bulk deliveries with real-time cost updates.
                    </p>
                  </div>
                </StaggeredReveal>
                <StaggeredReveal delay={1.1}>
                  <div className="relative">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">Digital Payments</h3>
                    <p className="mt-2 text-base text-gray-500 dark:text-gray-300">
                      Accept payments via M-Pesa, bank transfers, and crypto, plus access to micro-loans.
                    </p>
                  </div>
                </StaggeredReveal>
                <StaggeredReveal delay={1.2}>
                  <div className="relative">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">Pest & Disease Detection</h3>
                    <p className="mt-2 text-base text-gray-500 dark:text-gray-300">
                      Upload crop pictures for AI-powered disease detection and solution recommendations.
                    </p>
                  </div>
                </StaggeredReveal>
              </div>
            </div>
          </div>
        </div>
      </StaggeredReveal>

      {/* CTA section */}
      <StaggeredReveal delay={1.4}>
        <div className="bg-green-700 dark:bg-green-900 transition-colors duration-200">
          <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
            <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              <span className="block">Ready to access these services?</span>
              <span className="block text-green-200">Start using our platform today.</span>
            </h2>
            <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
              <div className="inline-flex rounded-md shadow">
                <Link
                  to="/register"
                  className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-green-600 bg-white hover:bg-green-50"
                >
                  Get started
                </Link>
              </div>
            </div>
          </div>
        </div>
      </StaggeredReveal>
    </PageTransition>
  );
};

export default Services; 